<template>
  <v-form>
    <v-row>
      <v-main>
        <v-row v-if="!cadastroConcluidoComPendencia" class="d-flex space-between px-lg-15 py-lg-3">
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              outlined
              hint="Codigo do novo empenho"
              v-model="dadosEmpenho.idEmpenho"
            >
              <template class="m-p-4" v-slot:label>
                <strong>ID DO EMPENHO</strong>
                <v-icon style="vertical-align: middle">mdi-key-variant</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              origin="center center"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="dadosEmpenho.dataEmpenho"
                  label="DATA DO EMPENHO"
                  hint="Data deste empenho"
                  persistent-hint
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dadosEmpenho.dataEmpenho"
                :active-picker.sync="activePicker"
                min="1950-01-01"
                @change="dateSave"
              />
            </v-menu>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-btn block x-large color="#943634" @click="criarEmpenho" v-on:dblclick.prevent>
              <v-icon left color="#fff">mdi-clipboard-check-outline</v-icon>
              <span style="color:white;">CADASTRAR EMPENHO</span>
            </v-btn>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <gerenciadorAnexos
              ref="anexosEmpenho"
              tipo-entidade="empenho"
              modo="fila_local"
              :entidade-id="registroCriadoId"
              mensagem-opcional="Os anexos sao opcionais e serao enviados apos salvar o empenho."
            />
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="dadosEmpenho.tipoEmpenho"
              :items="tipoEmpenho"
              dense
              chips
              label="Tipo do Empenho"
            />
          </v-col>
        </v-row>
      </v-main>

      <v-col v-if="!cadastroConcluidoComPendencia" cols="12" lg="12" md="12" sm="12">
        <listaProdutosEmpenhoStart :pregaoId="itemPregao.id" />
      </v-col>

      <v-col cols="12" lg="12" md="12" sm="12">
        <v-alert
          v-if="cadastroConcluidoComPendencia"
          type="warning"
          outlined
          class="mb-4"
        >
          Empenho salvo. Revise os anexos pendentes abaixo ou feche esta tela.
        </v-alert>

        <div v-if="cadastroConcluidoComPendencia" class="d-flex justify-end mb-4">
          <v-btn text color="#75756d" @click="fecharAposPendencia">Fechar</v-btn>
        </div>

        <gerenciadorAnexos
          v-if="cadastroConcluidoComPendencia"
          ref="anexosEmpenho"
          tipo-entidade="empenho"
          modo="fila_local"
          :entidade-id="registroCriadoId"
          mensagem-opcional="Os anexos sao opcionais e serao enviados apos salvar o empenho."
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import axios from "axios";
import barramento from "@/barramento";
import { urlApi, showError } from "@/global";
import gerenciadorAnexos from "../anexos/gerenciadorAnexos";
import listaProdutosEmpenhoStart from "./listaProdutosEmpenhoStart";

export default {
  name: "cadastroEmpenho",
  props: {
    itemPregao: {},
    listaEmpenhos: [],
    isEmpenho: [Boolean, Function],
    somaValorTotalEntregueEmpenho: [String, Number],
  },
  components: { gerenciadorAnexos, listaProdutosEmpenhoStart },

  data: () => ({
    tipoEmpenho: ["Global", "Ordinario"],
    dadosEmpenho: {},
    itensSelecionados: [],
    valorTotalEm: 0,
    activePicker: null,
    menu: false,
    primeiroEmpenho: false,
    produtosEmpenhoListener: null,
    totalEmpenhoListener: null,
    cadastroConcluidoComPendencia: false,
    registroCriadoId: null,
  }),

  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "Ano"));
    },
  },

  methods: {
    limparForm() {
      this.dadosEmpenho = {};
      this.itensSelecionados = [];
      this.cadastroConcluidoComPendencia = false;
      this.registroCriadoId = null;
      if (this.$refs.anexosEmpenho) {
        this.$refs.anexosEmpenho.resetState();
      }
    },

    dateSave(date) {
      this.$refs.menu.save(date);
    },

    fecharAposPendencia() {
      this.limparForm();
      document.getElementById("js-modal-empenho__close").click();
    },

    async criarEmpenho() {
      const itensFiltrados = this.itensSelecionados.filter((it) => (it.quantEmpenho || 0) > 0);

      if (itensFiltrados.length === 0) {
        showError("Informe a quantidade para pelo menos um item.");
        return;
      }

      const payload = {
        idEmpenho: this.dadosEmpenho.idEmpenho,
        dataEmpenho: this.dadosEmpenho.dataEmpenho,
        tipoEmpenho: this.dadosEmpenho.tipoEmpenho,
        idRefPregao: this.itemPregao.id,
        isPrimeiro: this.primeiroEmpenho,
        notificaoNf: true,
        itens_empenho: itensFiltrados.map((it) => ({
          item_pregao_id: it.id,
          quantidade_empenhada: it.quantEmpenho,
        })),
      };

      try {
        const res = await axios.post(`${urlApi}/empenho`, payload);
        const empenhoId = res && res.data ? res.data.id : null;
        const anexoRef = this.$refs.anexosEmpenho;

        barramento.EnviarLoadEmpenho(true, this.itemPregao.id);

        if (anexoRef && anexoRef.hasPendingFiles()) {
          if (!empenhoId) {
            this.registroCriadoId = null;
            this.cadastroConcluidoComPendencia = true;
            this.$toasted.global.defaultError({
              msg: "Empenho salvo, mas o ID nao foi retornado para enviar os anexos.",
            });
            return;
          }

          this.registroCriadoId = empenhoId;
          const uploadResult = await anexoRef.uploadPendingFiles({
            entidadeId: empenhoId,
            silentSuccess: true,
          });

          barramento.EnviarLoadEmpenho(true, this.itemPregao.id);

          if (uploadResult.failed.length > 0) {
            this.cadastroConcluidoComPendencia = true;
            this.$toasted.global.defaultError({
              msg: "Empenho salvo, mas alguns anexos falharam. Revise a secao de documentos.",
            });
            return;
          }
        }

        this.limparForm();
        document.getElementById("js-modal-empenho__close").click();
        this.$toasted.global.defaultSuccess();
      } catch (err) {
        showError(err);
      }
    },
  },

  created() {
    this.produtosEmpenhoListener = (listaItens, isPrimeiro) => {
      this.itensSelecionados = listaItens;
      this.primeiroEmpenho = isPrimeiro;
    };
    barramento.getProdutosEmpenho(this.produtosEmpenhoListener);
    this.totalEmpenhoListener = (vtotal) => {
      this.valorTotalEm = vtotal;
    };
    barramento.getTotalEmpenho(this.totalEmpenhoListener);
  },
  beforeDestroy() {
    if (this.produtosEmpenhoListener) {
      barramento.$off("getProdutosEmpenho", this.produtosEmpenhoListener);
    }
    if (this.totalEmpenhoListener) {
      barramento.$off("getTotalEmpenho", this.totalEmpenhoListener);
    }
  },
};
</script>

<style>
.form-pregao__item {
  font-family: "Georama", sans-serif !important;
}
</style>
